import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-client-popup',
  templateUrl: './client-popup.component.html',
  styleUrls: ['./client-popup.component.scss'],
})
export class ClientPopupComponent {
  client_name: string = '';
  constructor(
    public dialogRef: MatDialogRef<ClientPopupComponent>,
    private requestFormService: RequestFormService
  ) {}

 onSubmit(isSubmit: boolean) {
  const payload = {
    client_name: this.client_name?.trim(),
  };

  if (!isSubmit) {
    this.dialogRef.close();
    return;
  }

  this.requestFormService.updateClientData(payload).subscribe({
    next: (res: any) => {
      if (res?.status === 'success') {
        this.dialogRef.close('success');
      } else {
        this.dialogRef.close('failed');
      }
    },
    error: (err) => {
      console.error('Client Save Error:', err);
      this.dialogRef.close('error');
    }
  });
}


}
